import * as Yup from "yup";

import LiquidTemplate, {
  LIQUID_VARIABLE_NAME_MATCHER,
} from "@stw/liquid-template";

import { CampaignContactFieldFieldsFragment } from "~frontend/__generated__/graphql";
import {
  CampaignForEditor,
  CampaignContactField,
} from "~frontend/routes/subaccounts/campaignEditor/types";

export function scriptsContainField(
  campaign: CampaignForEditor,
  contactField: CampaignContactField
): boolean {
  const personalizedGifFields = campaign.scriptVariants.flatMap(variant => {
    if (variant.personalizedGif) {
      return variant.personalizedGif.creatomateTemplate.requiredContactFields.map(
        field => field.name
      );
    } else {
      return [];
    }
  });

  if (personalizedGifFields.includes(contactField.name)) {
    return true;
  }

  const allScripts = campaign.scriptVariants
    .map(v => v.script)
    .concat(
      campaign.responseScriptGroups.flatMap(group =>
        group.memberships.flatMap(m => m.script.script)
      )
    );

  return allScripts.some(script => {
    const parseResult = LiquidTemplate.fromString(script);
    if (!parseResult.ok) {
      return false;
    }

    return parseResult.template
      .getRequiredAndAssignedVariables()
      .includes(contactField.name);
  });
}

export function contactFieldNameSchema({
  otherFieldNames,
}: {
  otherFieldNames: string[];
}): Yup.StringSchema {
  return Yup.string()
    .required("Required")
    .matches(
      LIQUID_VARIABLE_NAME_MATCHER,
      "Only letters, numbers, and underscores are allowed"
    )
    .test(
      "unique",
      "This field already exists",
      value => !value || !otherFieldNames.includes(value)
    );
}

export type CampaignContactFieldsForMapping = Pick<
  CampaignContactFieldFieldsFragment,
  "name" | "contactDataKey" | "builtIn"
>[];
export function formatContactData({
  contactData,
  campaignContactFields,
}: {
  contactData: Record<string, string>;
  campaignContactFields: CampaignContactFieldsForMapping;
}): {
  formattedData: Record<string, string>;
  firstName?: string;
  lastName?: string;
} {
  const formattedData: Record<string, string> = {};
  let firstName: string | undefined;
  let lastName: string | undefined;

  campaignContactFields.forEach(field => {
    if (!field.contactDataKey) {
      return;
    }

    const value = contactData[field.contactDataKey] || "";
    formattedData[field.name] = value;

    if (field.builtIn && field.name === "first_name") {
      firstName = value;
    }

    if (field.builtIn && field.name === "last_name") {
      lastName = value;
    }
  });

  return { formattedData, firstName, lastName };
}
